<template>
  <div class="list-manage">
    <el-form ref="form" :model="form" label-width="80px">
      <div class="clear"></div>
      <div class="list-manage-text" style="overflow:hidden">
        <div class="list-manage-text-left left">
          <el-button type="primary" size="small" @click="goInfo()">新建发型师</el-button>
          <!-- <span>
            <el-input type="file" webkitdirectory></el-input>
          </span> -->
        </div>
        <div class="list-manage-text-right right wrap" style="width: 100%;">
          <el-date-picker type="date" placeholder="入职时间" v-model="form.value" size="small"
            value-format="yyyy-MM-dd"></el-date-picker>
          <el-select v-model="form.type" size="small" @change="getWorkerList()" placeholder="职位" style="width: 120px"
            clearable>
            <el-option label="店员" value="0"></el-option>
            <el-option label="店长" value="1"></el-option>
          </el-select>
          <el-select v-model="form.shop" size="small" placeholder="全部店铺" @change="getWorkerList()" style="width: 120px"
            clearable filterable>
            <el-option v-for="item in form.shops" :key="item.id" :label="item.title" :value="item.id"> </el-option>
          </el-select>
          <el-select v-model="form.state" size="small" placeholder="状态" style="width: 120px" clearable>
            <el-option label="全部" value=""></el-option>
            <!-- 						<el-option label="测试人员" value="0"></el-option>
						<el-option label="学习期" value="1"></el-option> -->
            <el-option label="待分配" value="2"></el-option>
            <el-option label="试用期" value="3"></el-option>
            <!-- 						<el-option label="在职-上班" value="4"></el-option>
						<el-option label="在职-调休" value="5"></el-option>
						<el-option label="在职-假期" value="6"></el-option>
						<el-option label="在职-休假" value="7"></el-option> -->
            <el-option label="离职" value="8"></el-option>
          </el-select>
          <el-select v-model="form.isRemove" placeholder="上下架" size="small" style="width: 100px;" clearable>
            <el-option :key="0" :value="0" label="上架"></el-option>
            <el-option :key="1" :value="1" label="下架"></el-option>
          </el-select>
          <el-select v-model="form.workerStatus" placeholder="状态" size="small" style="width: 100px;" clearable>
            <el-option key="0" :value="0" label="上班"></el-option>
            <el-option key="11" :value="11" label="轻餐"></el-option>
            <el-option key="4" :value="4" label="外出"></el-option>
            <el-option key="1" :value="1" label="就餐"></el-option>
            <el-option key="3" :value="3" label="即将下班"></el-option>
            <el-option key="2" :value="2" label="休息"></el-option>
          </el-select>
          <el-input v-model="form.name" size="small" @keydown.enter.native="getWorkerList()" placeholder="输入员工名称或手机"
            style="width: 200px"></el-input>
          <el-button type="primary" size="small" @click="(form.page = 1), getWorkerList()">筛选 </el-button>
          <!-- 批量修改服务和价格 -->
          <!-- <div class="top right"> -->
          <!-- <span>输入服务价格</span> -->
          <span class="right">
            <el-input-number :precision="2" :min="0" v-model="price" size="small" placeholder="输入服务价格">
            </el-input-number>
            <el-dropdown @command="changeService">
              <el-button size="small" type="info">一键修改服务</el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command>显示价格</el-dropdown-item>
                <el-dropdown-item v-for="item in serviceList" :key="item.id" :command="item">{{ item.title }} {{
                  item.price }}元</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <el-dropdown @command="changeWorkerStatus">
              <el-button size="small" type="info" style="margin-left: 10px;">一键修改状态</el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="0">上班</el-dropdown-item>
                <el-dropdown-item command="11">轻餐</el-dropdown-item>
                <el-dropdown-item command="4">外出</el-dropdown-item>
                <el-dropdown-item command="1">就餐</el-dropdown-item>
                <el-dropdown-item command="3">即将下班</el-dropdown-item>
                <el-dropdown-item command="2">休息</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </span>
          <!-- </div> -->
        </div>
      </div>
    </el-form>
    <!-- 数据表格 -->
    <div class="list-manage-form" style="margin-top: 10px;" v-loading="loading">
      <el-tabs type="card">
        <el-tab-pane label="正职">
          <el-table :data="workList" height="60vh" ref="multipleTable" @selection-change="handleSelectionChange" stripe
            :header-cell-style="{ background: '#d8d8d8', 'text-align': 'center', color: '#2D2D2D', height: '20px' }"
            style="width: 100%">
            <el-table-column type="selection" width="55"> </el-table-column>
            <el-table-column prop="id" label="工号" width="90px"></el-table-column>
            <el-table-column label="头像" width="120px">
              <template slot-scope="scope">
                <el-avatar :size="60" :src="scope.row.avatar"></el-avatar>
              </template>
            </el-table-column>
            <el-table-column prop="name" label="姓名" width="100px"></el-table-column>
            <el-table-column prop="nameEn" label="昵称" width="100px"></el-table-column>
            <el-table-column prop="telphone" label="手机号" width="120px"></el-table-column>
            <el-table-column prop="storeName" label="所属门店">
              <template slot-scope="scope">
                {{ scope.row.storeName ? scope.row.storeName : "暂无" }}
              </template>
            </el-table-column>
            <el-table-column prop="maxPrice" label="显示价格">
              <template slot-scope="scope">
                <span style="font-family: SourceHanSansCN-Bold;"> ￥{{ (scope.row.maxPrice / 100).toFixed(2) }} </span>
              </template>
            </el-table-column>
            <el-table-column prop="position" label="职位" width="80px">
              <template slot-scope="scope">
                <div v-if="scope.row.type == 0">
                  <el-tag type="info" style="color: #3E3E3E;">店员</el-tag>
                </div>
                <div v-else-if="scope.row.type == 1">
                  <el-tag>店长</el-tag>
                </div>
                <div v-else-if="scope.row.type == 2">试用期</div>
              </template>
            </el-table-column>
            <el-table-column prop="levelTitle" label="级别">
              <template slot-scope="scope">
                <el-tag v-if="scope.row.levelTitle == '资深发型师' || scope.row.levelTitle == ''" type="info"
                  style="color: #3E3E3E;">
                  {{ scope.row.levelTitle == "" ? "不显示" : scope.row.levelTitle }}
                </el-tag>
                <el-tag v-else>{{ scope.row.levelTitle }}</el-tag>
              </template>
            </el-table-column>
            <el-table-column label="试工">
              <template slot-scope="{ row }">
                <el-tag v-if="row.test == 1">试工</el-tag>
                <el-tag v-else type="success">正职</el-tag>
              </template>
            </el-table-column>
            <el-table-column label="状态">
              <template slot-scope="{ row }">
                <el-tag v-if="row.workerStatus == 0" type="success">上班</el-tag>
                <el-tag v-if="row.workerStatus == 1" type="warning">就餐</el-tag>
                <el-tag v-if="row.workerStatus == 11" type="warning">轻餐</el-tag>
                <el-tag v-if="row.workerStatus == 4" type="primary">外出</el-tag>
                <el-tag v-if="row.workerStatus == 2" type="danger">休息</el-tag>
                <el-tag v-if="row.workerStatus == 3" type="info">即将下班</el-tag>
                <!-- {{row.workerStatus ==0?'上班':row.workerStatus ==1?'就餐':row.workerStatus ==2?'休息':row.workerStatus ==3?'即将下班':row.workerStatus ==11?'轻餐':'未知'}} -->
              </template>
            </el-table-column>
            <el-table-column prop="isRemove" label="上下架">
              <template slot-scope="{ row }">
                <el-tag v-if="row.isRemove == 0" type="success">上架</el-tag>
                <el-tag v-else type="danger">下架</el-tag>
              </template>
            </el-table-column>
            <!-- 				<el-table-column prop="remark" label="备注">

									</el-table-column> -->
            <el-table-column prop="joinTime" label="入职时间"></el-table-column>
            <el-table-column prop="position" label="专属二维码" width="120">
              <template slot-scope="scope">
                <a :href="scope.row.qrcode" v-if="scope.row.qrcode != null">
                  <el-image :src="scope.row.qrcode" style="width:60px"></el-image>
                </a>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="150px">
              <template slot-scope="scope">
                <div>
<!--                  <el-button type="text" size="small" @click="getService(scope.row.id)">服务</el-button>-->
                  <el-button type="text" size="small" @click="handleEditService(scope.row.id)">服务</el-button>
                  <el-button @click="goInfo(scope.row.id)" type="text" size="small">编辑</el-button>
                </div>
                <div>
                  <el-button type="text" size="small" @click="out(scope.row)" v-if="scope.row.status != 8">离职
                  </el-button>
                  <el-button type="text" size="small" @click="out(scope.row)" v-if="scope.row.status == 8">
                    <div style="color: red">
                      删除
                    </div>
                  </el-button>
                  <el-button type="text" @click="handleStatusClick(scope.row.id)">状态</el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane label="试工">
          <el-table :data="workTestList" height="60vh"
            :header-cell-style="{ background: '#d8d8d8', 'text-align': 'center', color: '#2D2D2D', height: '20px' }"
            style="width: 100%">
            <el-table-column prop="id" label="工号" width="90px"></el-table-column>
            <el-table-column label="头像" width="120px">
              <template slot-scope="scope">
                <el-avatar :size="60" :src="scope.row.avatar"></el-avatar>
              </template>
            </el-table-column>
            <el-table-column prop="name" label="姓名" width="100px"></el-table-column>
            <el-table-column prop="nameEn" label="昵称" width="100px"></el-table-column>
            <el-table-column prop="telphone" label="手机号" width="120px"></el-table-column>
            <el-table-column prop="storeName" label="所属门店">
              <template slot-scope="scope">
                {{ scope.row.storeName ? scope.row.storeName : "暂无" }}
              </template>
            </el-table-column>
            <el-table-column prop="maxPrice" label="显示价格">
              <template slot-scope="scope">
                <span style="font-family: SourceHanSansCN-Bold;"> ￥{{ (scope.row.maxPrice / 100).toFixed(2) }} </span>
              </template>
            </el-table-column>
            <el-table-column prop="position" label="职位" width="80px">
              <template slot-scope="scope">
                <div v-if="scope.row.type == 0">
                  <el-tag type="info" style="color: #3E3E3E;">店员</el-tag>
                </div>
                <div v-else-if="scope.row.type == 1">
                  <el-tag>店长</el-tag>
                </div>
                <div v-else-if="scope.row.type == 2">试用期</div>
              </template>
            </el-table-column>
            <el-table-column prop="levelTitle" label="级别">
              <template slot-scope="scope">
                <el-tag v-if="scope.row.levelTitle == '资深发型师' || scope.row.levelTitle == ''" type="info"
                  style="color: #3E3E3E;">
                  {{ scope.row.levelTitle == "" ? "不显示" : scope.row.levelTitle }}
                </el-tag>
                <el-tag v-else>{{ scope.row.levelTitle }}</el-tag>
              </template>
            </el-table-column>
            <el-table-column label="试工">
              <template slot-scope="{ row }">
                <el-tag v-if="row.test == 1">试工</el-tag>
                <el-tag v-else type="success">正职</el-tag>
              </template>
            </el-table-column>
            <el-table-column label="状态">
              <template slot-scope="{ row }">
                <el-tag v-if="row.workerStatus == 0" type="success">上班</el-tag>
                <el-tag v-if="row.workerStatus == 1" type="warning">就餐</el-tag>
                <el-tag v-if="row.workerStatus == 11" type="warning">轻餐</el-tag>
                <el-tag v-if="row.workerStatus == 4" type="primary">外出</el-tag>
                <el-tag v-if="row.workerStatus == 2" type="danger">休息</el-tag>
                <el-tag v-if="row.workerStatus == 3" type="info">即将下班</el-tag>
                <!-- {{row.workerStatus ==0?'上班':row.workerStatus ==1?'就餐':row.workerStatus ==2?'休息':row.workerStatus ==3?'即将下班':row.workerStatus ==11?'轻餐':'未知'}} -->
              </template>
            </el-table-column>
            <el-table-column prop="isRemove" label="上下架">
              <template slot-scope="{ row }">
                <el-tag v-if="row.isRemove == 0" type="success">上架</el-tag>
                <el-tag v-else type="danger">下架</el-tag>
              </template>
            </el-table-column>
            <!-- 				<el-table-column prop="remark" label="备注">

									</el-table-column> -->
            <el-table-column prop="joinTime" label="入职时间"></el-table-column>
            <el-table-column prop="position" label="专属二维码">
              <template slot-scope="scope">
                <a :href="scope.row.qrcode" v-if="scope.row.qrcode != null">
                  <el-image :src="scope.row.qrcode" style="width:60px"></el-image>
                </a>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="150px">
              <template slot-scope="scope">
                <div>
<!--                  <el-button type="text" size="small" @click="getService(scope.row.id)">服务</el-button>-->
                  <el-button type="text" size="small" @click="handleEditService(scope.row.id)">服务</el-button>
                  <el-button @click="goInfo(scope.row.id)" type="text" size="small">编辑</el-button>
                </div>
                <div>
                  <el-button type="text" size="small" @click="out(scope.row)" v-if="scope.row.status != 8">离职
                  </el-button>
                  <el-button type="text" size="small" @click="out(scope.row)" v-if="scope.row.status == 8">
                    <div style="color: red">
                      删除
                    </div>
                  </el-button>
                  <el-button type="text" @click="handleStatusClick(scope.row.id)">状态</el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
      </el-tabs>
      <div class="pagescg">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="form.page"
          :page-sizes="[10, 20, 30, 50]" :page-size="form.size" layout="total, sizes, prev, pager, next, jumper"
          :total="form.total"> </el-pagination>
      </div>
    </div>
    <el-dialog class="dialog" width="1260px" height="60vh" :destroy-on-close="true" :fullscreen="false" top="1vh"
      :visible.sync="serviceWindow">
      <div v-loading="loading">
        <div style="font-size: 18px; margin-bottom: 10px">
          <div style="display: flex;margin-top: -20px;margin-bottom: 10px;">
            <b style="margin-left: 20px;"> 显示价格</b>
            <span style="margin-left: 80px;">
              <el-input-number v-model="showPrice" :precision="2" :min="0" size="small"></el-input-number>
            </span>
            <b style="margin-left: 52px;"> 预约服务</b>
            <span style="margin-left: 80px;">
              <el-switch v-model="subscribe" :active-value="1" :inactive-value="0" />
            </span>
            <span style="margin-left: 20px;" v-if="subscribe">
              <el-time-select placeholder="起始时间" v-model="subscribeTimes[0]" :picker-options="{
                start: '09:00',
                step: '00:30',
                end: '23:59',
              }" size="small" style="margin-left: 20px; width:150px" @blur="$forceUpdate()">
              </el-time-select>
              <el-time-select placeholder="结束时间" v-model="subscribeTimes[1]" :picker-options="{
                start: '09:30',
                step: '00:30',
                end: '23:59',
                minTime: startTime,
              }" size="small" style="width:150px" @blur="$forceUpdate()">
              </el-time-select>
            </span>
          </div>
          <b style="margin-left: 20px;">服务项目</b>
          <b style="margin-left: 110px;">金额设置</b>
          <b style="margin-left: 80px;">业绩设置</b>
          <b style="margin-left: 145px;">闲时时间范围</b>
          <b style="margin-left: 150px;">闲时价格</b>
          <b style="margin-left: 40px;">启动闲时</b>
          <b style="margin-left: 80px;">标签</b>
        </div>
        <el-row class="dialog-warpper">
          <div v-for="stype in serviceType">
            <b>{{stype.name}}</b>
          <el-checkbox-group v-model="setObj.serviceList">
            <div v-for="item in serviceList" :key="item.id">
              <el-checkbox :label="item" v-if="item.type == stype.id"
                style="display:inline-block; width: 150px;margin-left: 25px;">{{ item.title }}</el-checkbox>
              <span v-if="item.type == stype.id && item.state == 1" style=" width: 100px;">
                <el-input-number :precision="2" :min="0" v-model="item.price" size="small"> </el-input-number>
                <el-input-number :precision="2" :min="0" v-model="item.commission" size="small"
                  style="margin-left: 20px;">
                </el-input-number>
                <el-time-select placeholder="起始时间" v-model="item.leisureStartTime" :picker-options="{
                  start: '09:00',
                  step: '00:10',
                  end: '23:59',
                }" size="small" style="margin-left: 20px; width:150px" @blur="$forceUpdate()">
                </el-time-select>
                <el-time-select placeholder="结束时间" v-model="item.leisureEndTime" :picker-options="{
                  start: '09:30',
                  step: '00:10',
                  end: '23:59',
                  minTime: startTime,
                }" size="small" style="width:150px" @blur="$forceUpdate()">
                </el-time-select>
                <el-input-number :precision="2" :min="0" v-model="item.leisurePrice" size="small"
                  style="margin-left: 20px;"> </el-input-number>
                <el-button v-if="item.isLeisure == true" @click="setLeisure(item.id)" size="small"
                  style="color: green;margin-left: 20px;">
                  已开启
                </el-button>
                <el-button v-else-if="item.isLeisure == false" @click="setLeisure(item.id)" size="small"
                  style="color: #c6c6c6;margin-left: 20px;">
                  已关闭
                </el-button>
                <el-input v-model="item.tag" style="margin-left: 20px;width: 160px;" size="small"
                  @input="$forceUpdate()"></el-input>
              </span>
            </div>
          </el-checkbox-group>
          </div>
        </el-row>
        <!-- <el-row class="dialog-warpper">
          <b>剪发服务</b>
          <el-checkbox-group v-model="setObj.serviceList">
            <div v-for="item in serviceList" :key="item.id">
              <el-checkbox :label="item" v-if="item.type == 0"
                style="display:inline-block; width: 150px;margin-left: 25px;">{{ item.title }}</el-checkbox>
              <span v-if="item.type == 0 && item.state == 1" style=" width: 100px;">
                <el-input-number :precision="2" :min="0" v-model="item.price" size="small"> </el-input-number>
                <el-input-number :precision="2" :min="0" v-model="item.commission" size="small"
                  style="margin-left: 20px;">
                </el-input-number>
                <el-time-select placeholder="起始时间" v-model="item.leisureStartTime" :picker-options="{
                  start: '09:00',
                  step: '00:10',
                  end: '23:59',
                }" size="small" style="margin-left: 20px; width:150px" @blur="$forceUpdate()">
                </el-time-select>
                <el-time-select placeholder="结束时间" v-model="item.leisureEndTime" :picker-options="{
                  start: '09:30',
                  step: '00:10',
                  end: '23:59',
                  minTime: startTime,
                }" size="small" style="width:150px" @blur="$forceUpdate()">
                </el-time-select>
                <el-input-number :precision="2" :min="0" v-model="item.leisurePrice" size="small"
                  style="margin-left: 20px;"> </el-input-number>
                <el-button v-if="item.isLeisure == true" @click="setLeisure(item.id)" size="small"
                  style="color: green;margin-left: 20px;">
                  已开启
                </el-button>
                <el-button v-else-if="item.isLeisure == false" @click="setLeisure(item.id)" size="small"
                  style="color: #c6c6c6;margin-left: 20px;">
                  已关闭
                </el-button>
                <el-input v-model="item.tag" style="margin-left: 20px;width: 160px;" size="small"
                  @input="$forceUpdate()"></el-input>
              </span>
            </div>
          </el-checkbox-group>
          <b>烫染服务</b>
          <el-checkbox-group v-model="setObj.serviceList">
            <div v-for="item in serviceList" :key="item.id">
              <el-checkbox :label="item" v-if="item.type == 1 && item.state == 1"
                style="display:inline-block; width: 150px;margin-left: 25px;">{{ item.title }}</el-checkbox>
              <span v-if="item.type == 1 && item.state == 1" style=" width: 100px;">
                <el-input-number :precision="2" :min="0" v-model="item.price" size="small"> </el-input-number>
                <el-input-number :precision="2" :min="0" v-model="item.commission" size="small"
                  style="margin-left: 20px;">
                </el-input-number>
                <el-time-select placeholder="起始时间" v-model="item.leisureStartTime" :picker-options="{
                  start: '09:00',
                  step: '00:10',
                  end: '23:59',
                }" size="small" style="margin-left: 20px; width:150px">
                </el-time-select>
                <el-time-select placeholder="结束时间" v-model="item.leisureEndTime" :picker-options="{
                  start: '09:30',
                  step: '00:10',
                  end: '23:59',
                  minTime: startTime,
                }" size="small" style="width:150px">
                </el-time-select>
                <el-input-number :precision="2" :min="0" v-model="item.leisurePrice" size="small"
                  style="margin-left: 20px;"> </el-input-number>
                <el-button v-if="item.isLeisure == true" @click="setLeisure(item.id)" size="small"
                  style="color: green;margin-left: 20px;">
                  已开启
                </el-button>
                <el-button v-else-if="item.isLeisure == false" @click="setLeisure(item.id)" size="small"
                  style="color: #c6c6c6;margin-left: 20px;">
                  已关闭
                </el-button>
                <el-input v-model="item.tag" @input="$forceUpdate()" style="margin-left: 20px;width: 160px;"
                  size="small"></el-input>
              </span>
            </div>
          </el-checkbox-group>
          <b>洗吹服务</b>
          <el-checkbox-group v-model="setObj.serviceList">
            <div v-for="item in serviceList" :key="item.id">
              <el-checkbox :label="item" v-if="item.type == 2 && item.state == 1"
                style="display:inline-block; width: 150px;margin-left: 25px;">{{ item.title }}</el-checkbox>
              <span v-if="item.type == 2 && item.state == 1" style=" width: 100px;">
                <el-input-number :precision="2" :min="0" v-model="item.price" size="small"> </el-input-number>
                <el-input-number :precision="2" :min="0" v-model="item.commission" size="small"
                  style="margin-left: 20px;">
                </el-input-number>
                <el-time-select placeholder="起始时间" v-model="item.leisureStartTime" :picker-options="{
                  start: '09:00',
                  step: '00:10',
                  end: '23:59',
                }" size="small" style="margin-left: 20px; width:150px" @blur="$forceUpdate()">
                </el-time-select>
                <el-time-select placeholder="结束时间" v-model="item.leisureEndTime" :picker-options="{
                  start: '09:30',
                  step: '00:10',
                  end: '23:59',
                  minTime: startTime,
                }" size="small" style="width:150px" @blur="$forceUpdate()">
                </el-time-select>
                <el-input-number :precision="2" :min="0" v-model="item.leisurePrice" size="small"
                  style="margin-left: 20px;"> </el-input-number>
                <el-button v-if="item.isLeisure == true" @click="setLeisure(item.id)" size="small"
                  style="color: green;margin-left: 20px;">
                  已开启
                </el-button>
                <el-button v-else-if="item.isLeisure == false" @click="setLeisure(item.id)" size="small"
                  style="color: #c6c6c6;margin-left: 20px;">
                  已关闭
                </el-button>
                <el-input v-model="item.tag" @input="$forceUpdate()" style="margin-left: 20px;width: 160px;"
                  size="small"></el-input>
              </span>
            </div>
          </el-checkbox-group>
          <b>护理服务</b>
          <el-checkbox-group v-model="setObj.serviceList">
            <div v-for="item in serviceList" :key="item.id">
              <el-checkbox :label="item" v-if="item.type == 3 && item.state == 1"
                style="display:inline-block; width: 150px;margin-left: 25px;">{{ item.title }}</el-checkbox>
              <span v-if="item.type == 3 && item.state == 1" style=" width: 100px;">
                <el-input-number :precision="2" :min="0" v-model="item.price" size="small"> </el-input-number>
                <el-input-number :precision="2" :min="0" v-model="item.commission" size="small"
                  style="margin-left: 20px;">
                </el-input-number>
                <el-time-select placeholder="起始时间" v-model="item.leisureStartTime" :picker-options="{
                  start: '09:00',
                  step: '00:10',
                  end: '23:59',
                }" size="small" style="margin-left: 20px; width:150px" @blur="$forceUpdate()">
                </el-time-select>
                <el-time-select placeholder="结束时间" v-model="item.leisureEndTime" :picker-options="{
                  start: '09:30',
                  step: '00:10',
                  end: '23:59',
                  minTime: startTime,
                }" size="small" style="width:150px" @blur="$forceUpdate()">
                </el-time-select>
                <el-input-number :precision="2" :min="0" v-model="item.leisurePrice" size="small"
                  style="margin-left: 20px;"> </el-input-number>
                <el-button v-if="item.isLeisure == true" @click="setLeisure(item.id)" size="small"
                  style="color: green;margin-left: 20px;">
                  已开启
                </el-button>
                <el-button v-else-if="item.isLeisure == false" @click="setLeisure(item.id)" size="small"
                  style="color: #c6c6c6;margin-left: 20px;">
                  已关闭
                </el-button>
                <el-input v-model="item.tag" style="margin-left: 20px;width: 160px;" size="small"
                  @input="$forceUpdate()"></el-input>
              </span>
            </div>
          </el-checkbox-group>
          <b>造型</b>
          <el-checkbox-group v-model="setObj.serviceList">
            <div v-for="item in serviceList" :key="item.id">
              <el-checkbox :label="item" v-if="item.type == 4 && item.state == 1"
                style="display:inline-block; width: 150px;margin-left: 25px;">{{ item.title }}</el-checkbox>
              <span v-if="item.type == 4 && item.state == 1" style=" width: 100px;">
                <el-input-number :precision="2" :min="0" v-model="item.price" size="small"> </el-input-number>
                <el-input-number :precision="2" :min="0" v-model="item.commission" size="small"
                  style="margin-left: 20px;">
                </el-input-number>
                <el-time-select placeholder="起始时间" v-model="item.leisureStartTime" :picker-options="{
                  start: '09:00',
                  step: '00:10',
                  end: '23:59',
                }" size="small" style="margin-left: 20px; width:150px" @blur="$forceUpdate()">
                </el-time-select>
                <el-time-select placeholder="结束时间" v-model="item.leisureEndTime" :picker-options="{
                  start: '09:30',
                  step: '00:10',
                  end: '23:59',
                  minTime: startTime,
                }" size="small" style="width:150px" @blur="$forceUpdate()">
                </el-time-select>
                <el-input-number :precision="2" :min="0" v-model="item.leisurePrice" size="small"
                  style="margin-left: 20px;"> </el-input-number>
                <el-button v-if="item.isLeisure == true" @click="setLeisure(item.id)" size="small"
                  style="color: green;margin-left: 20px;">
                  已开启
                </el-button>
                <el-button v-else-if="item.isLeisure == false" @click="setLeisure(item.id)" size="small"
                  style="color: #c6c6c6;margin-left: 20px;">
                  已关闭
                </el-button>
                <el-input v-model="item.tag" style="margin-left: 20px;width: 160px;" size="small"
                  @input="$forceUpdate()"></el-input>
              </span>
            </div>
          </el-checkbox-group>
          <b>迷你烫</b>
          <el-checkbox-group v-model="setObj.serviceList">
            <div v-for="item in serviceList" :key="item.id">
              <el-checkbox :label="item" v-if="item.type == 5 && item.state == 1"
                style="display:inline-block; width: 150px;margin-left: 25px;">{{ item.title }}</el-checkbox>
              <span v-if="item.type == 5 && item.state == 1" style=" width: 100px;">
                <el-input-number :precision="2" :min="0" v-model="item.price" size="small"> </el-input-number>
                <el-input-number :precision="2" :min="0" v-model="item.commission" size="small"
                  style="margin-left: 20px;">
                </el-input-number>
                <el-time-select placeholder="起始时间" v-model="item.leisureStartTime" :picker-options="{
                  start: '09:00',
                  step: '00:10',
                  end: '23:59',
                }" size="small" style="margin-left: 20px; width:150px" @blur="$forceUpdate()">
                </el-time-select>
                <el-time-select placeholder="结束时间" v-model="item.leisureEndTime" :picker-options="{
                  start: '09:30',
                  step: '00:10',
                  end: '23:59',
                  minTime: startTime,
                }" size="small" style="width:150px" @blur="$forceUpdate()">
                </el-time-select>
                <el-input-number :precision="2" :min="0" v-model="item.leisurePrice" size="small"
                  style="margin-left: 20px;"> </el-input-number>
                <el-button v-if="item.isLeisure == true" @click="setLeisure(item.id)" size="small"
                  style="color: green;margin-left: 20px;">
                  已开启
                </el-button>
                <el-button v-else-if="item.isLeisure == false" @click="setLeisure(item.id)" size="small"
                  style="color: #c6c6c6;margin-left: 20px;">
                  已关闭
                </el-button>
                <el-input v-model="item.tag" style="margin-left: 20px;width: 160px;" size="small"
                  @input="$forceUpdate()"></el-input>
              </span>
            </div>
          </el-checkbox-group>
          <b>健康染发</b>
          <el-checkbox-group v-model="setObj.serviceList">
            <div v-for="item in serviceList" :key="item.id">
              <el-checkbox :label="item" v-if="item.type == 6 && item.state == 1"
                style="display:inline-block; width: 150px;margin-left: 25px;">{{ item.title }}</el-checkbox>
              <span v-if="item.type == 6 && item.state == 1" style=" width: 100px;">
                <el-input-number :precision="2" :min="0" v-model="item.price" size="small"> </el-input-number>
                <el-input-number :precision="2" :min="0" v-model="item.commission" size="small"
                  style="margin-left: 20px;">
                </el-input-number>
                <el-time-select placeholder="起始时间" v-model="item.leisureStartTime" :picker-options="{
                  start: '09:00',
                  step: '00:10',
                  end: '23:59',
                }" size="small" style="margin-left: 20px; width:150px" @blur="$forceUpdate()">
                </el-time-select>
                <el-time-select placeholder="结束时间" v-model="item.leisureEndTime" :picker-options="{
                  start: '09:30',
                  step: '00:10',
                  end: '23:59',
                  minTime: startTime,
                }" size="small" style="width:150px" @blur="$forceUpdate()">
                </el-time-select>
                <el-input-number :precision="2" :min="0" v-model="item.leisurePrice" size="small"
                  style="margin-left: 20px;"> </el-input-number>
                <el-button v-if="item.isLeisure == true" @click="setLeisure(item.id)" size="small"
                  style="color: green;margin-left: 20px;">
                  已开启
                </el-button>
                <el-button v-else-if="item.isLeisure == false" @click="setLeisure(item.id)" size="small"
                  style="color: #c6c6c6;margin-left: 20px;">
                  已关闭
                </el-button>
                <el-input v-model="item.tag" style="margin-left: 20px;width: 160px;" size="small"
                  @input="$forceUpdate()"></el-input>
              </span>
            </div>
          </el-checkbox-group>
          <b>健康烫发</b>
          <el-checkbox-group v-model="setObj.serviceList">
            <div v-for="item in serviceList" :key="item.id">
              <el-checkbox :label="item" v-if="item.type == 7 && item.state == 1"
                style="display:inline-block; width: 150px;margin-left: 25px;">{{ item.title }}</el-checkbox>
              <span v-if="item.type == 7 && item.state == 1" style=" width: 100px;">
                <el-input-number :precision="2" :min="0" v-model="item.price" size="small"> </el-input-number>
                <el-input-number :precision="2" :min="0" v-model="item.commission" size="small"
                  style="margin-left: 20px;">
                </el-input-number>
                <el-time-select placeholder="起始时间" v-model="item.leisureStartTime" :picker-options="{
                  start: '09:00',
                  step: '00:10',
                  end: '23:59',
                }" size="small" style="margin-left: 20px; width:150px" @blur="$forceUpdate()">
                </el-time-select>
                <el-time-select placeholder="结束时间" v-model="item.leisureEndTime" :picker-options="{
                  start: '09:30',
                  step: '00:10',
                  end: '23:59',
                  minTime: startTime,
                }" size="small" style="width:150px" @blur="$forceUpdate()">
                </el-time-select>
                <el-input-number :precision="2" :min="0" v-model="item.leisurePrice" size="small"
                  style="margin-left: 20px;"> </el-input-number>
                <el-button v-if="item.isLeisure == true" @click="setLeisure(item.id)" size="small"
                  style="color: green;margin-left: 20px;">
                  已开启
                </el-button>
                <el-button v-else-if="item.isLeisure == false" @click="setLeisure(item.id)" size="small"
                  style="color: #c6c6c6;margin-left: 20px;">
                  已关闭
                </el-button>
                <el-input v-model="item.tag" style="margin-left: 20px;width: 160px;" size="small"
                  @input="$forceUpdate()"></el-input>
              </span>
            </div>
          </el-checkbox-group>
          <b>洗吹护理</b>
          <el-checkbox-group v-model="setObj.serviceList">
            <div v-for="item in serviceList" :key="item.id">
              <el-checkbox :label="item" v-if="item.type == 8 && item.state == 1"
                style="display:inline-block; width: 150px;margin-left: 25px;">{{ item.title }}</el-checkbox>
              <span v-if="item.type == 8 && item.state == 1" style=" width: 100px;">
                <el-input-number :precision="2" :min="0" v-model="item.price" size="small"> </el-input-number>
                <el-input-number :precision="2" :min="0" v-model="item.commission" size="small"
                  style="margin-left: 20px;">
                </el-input-number>
                <el-time-select placeholder="起始时间" v-model="item.leisureStartTime" :picker-options="{
                  start: '09:00',
                  step: '00:10',
                  end: '23:59',
                }" size="small" style="margin-left: 20px; width:150px" @blur="$forceUpdate()">
                </el-time-select>
                <el-time-select placeholder="结束时间" v-model="item.leisureEndTime" :picker-options="{
                  start: '09:30',
                  step: '00:10',
                  end: '23:59',
                  minTime: startTime,
                }" size="small" style="width:150px" @blur="$forceUpdate()">
                </el-time-select>
                <el-input-number :precision="2" :min="0" v-model="item.leisurePrice" size="small"
                  style="margin-left: 20px;"> </el-input-number>
                <el-button v-if="item.isLeisure == true" @click="setLeisure(item.id)" size="small"
                  style="color: green;margin-left: 20px;">
                  已开启
                </el-button>
                <el-button v-else-if="item.isLeisure == false" @click="setLeisure(item.id)" size="small"
                  style="color: #c6c6c6;margin-left: 20px;">
                  已关闭
                </el-button>
                <el-input v-model="item.tag" style="margin-left: 20px;width: 160px;" size="small"
                  @input="$forceUpdate()"></el-input>
              </span>
            </div>
          </el-checkbox-group>
          <b>美甲</b>
          <el-checkbox-group v-model="setObj.serviceList">
            <div v-for="item in serviceList" :key="item.id">
              <el-checkbox :label="item" v-if="item.type == 9 && item.state == 1"
                style="display:inline-block; width: 150px;margin-left: 25px;">{{ item.title }}</el-checkbox>
              <span v-if="item.type == 9 && item.state == 1" style=" width: 100px;">
                <el-input-number :precision="2" :min="0" v-model="item.price" size="small"> </el-input-number>
                <el-input-number :precision="2" :min="0" v-model="item.commission" size="small"
                  style="margin-left: 20px;">
                </el-input-number>
                <el-time-select placeholder="起始时间" v-model="item.leisureStartTime" :picker-options="{
                  start: '09:00',
                  step: '00:10',
                  end: '23:59',
                }" size="small" style="margin-left: 20px; width:150px" @blur="$forceUpdate()">
                </el-time-select>
                <el-time-select placeholder="结束时间" v-model="item.leisureEndTime" :picker-options="{
                  start: '09:30',
                  step: '00:10',
                  end: '23:59',
                  minTime: startTime,
                }" size="small" style="width:150px" @blur="$forceUpdate()">
                </el-time-select>
                <el-input-number :precision="2" :min="0" v-model="item.leisurePrice" size="small"
                  style="margin-left: 20px;"> </el-input-number>
                <el-button v-if="item.isLeisure == true" @click="setLeisure(item.id)" size="small"
                  style="color: green;margin-left: 20px;">
                  已开启
                </el-button>
                <el-button v-else-if="item.isLeisure == false" @click="setLeisure(item.id)" size="small"
                  style="color: #c6c6c6;margin-left: 20px;">
                  已关闭
                </el-button>
                <el-input v-model="item.tag" style="margin-left: 20px;width: 160px;" size="small"
                  @input="$forceUpdate()"></el-input>
              </span>
            </div>
          </el-checkbox-group>
        </el-row> -->
        <div style="text-align: center; margin-top: 10px">
          <el-button type="primary" @click="setService">保存</el-button>
        </div>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="changeDialog" width="400px">
      <el-form inline="" label-width="100px" label-position="left">
        <el-form-item label="上班状态">
          <el-select v-model="worker.workerStatus" style="width: 200px;">
            <el-option key="0" :value="0" label="上班">上班</el-option>
            <el-option key="11" :value="11" label="轻餐">轻餐</el-option>
            <el-option key="4" :value="4" label="外出">外出</el-option>
            <el-option key="1" :value="1" label="就餐">就餐</el-option>
            <el-option key="3" :value="3" label="即将下班">即将下班</el-option>
            <el-option key="2" :value="2" label="休息">休息</el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="在职状态">
          <el-select v-model="worker.status" style="width: 200px;">
            <el-option key="3" :value="3" label="在职">在职</el-option>
            <el-option key="8" :value="8" label="离职">离职</el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="发型师上下架">
          <el-select v-model="worker.isRemove" style="width: 200px;">
            <el-option key="0" :value="0" label="上架">上架</el-option>
            <el-option key="1" :value="1" label="下架">下架</el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div style="margin-left: 40%;margin-top: 20%;">
        <el-button @click="changeDialog = false">取消</el-button>
        <el-button type="primary" @click="saveWorkerStatus()">保存</el-button>
      </div>
    </el-dialog>
    <Service ref="serviceRef"/>
  </div>
</template>

<script>
import Service from "@/components/hair/childlist/service.vue";
export default {
  components: {Service},
  data () {
    return {
      form: {
        name: "",
        value: "",
        position: "",
        shop: "",
        shops: [
          {
            value: "",
            label: "全部门店",
          },
        ],
        showPrice: "", //显示价格
        state: "3",
        isRemove: "",
        type: "",
        page: 1,
        size: 30,
        total: 100,
        workerStatus: "", //发型师状态
      },
      price: "",
      loading: false,
      serviceList: [],
      setObj: {
        id: undefined,
        serviceList: [],
      },
      startTime: "",
      showPrice: "",
      subscribe: 0, //启动预约服务
      subscribeTimes: [],
      worker: {},
      serviceWindow: false,
      changeDialog: false,
      tmpWorkerStatus: "",
      workList: [],
      workTestList: [],
      leaveList: [],
      serviceType: [
        {
          id: 0,
          name:'剪发服务'
        },
        {
          id: 1,
          name:'烫染服务'
        },
        {
          id: 2,
          name:'洗吹服务'
        },
        {
          id: 3,
          name:'护理服务'
        },
        {
          id: 4,
          name:'造型'
        },
        {
          id: 5,
          name:'迷你烫'
        },
        {
          id: 6,
          name:'健康染发'
        },
        {
          id: 7,
          name:'健康烫发'
        },
        {
          id: 8,
          name:'洗吹护理'
        },
        {
          id: 9,
          name:'美甲'
        }]
    };
  },
  methods: {
    open (path) {},
    handleEditService(id) {
      this.$refs.serviceRef.show(id)
    },
    getService (id) {
      this.serviceWindow = true;
      this.loading = true;
      this.setObj = {
        id: id,
        serviceList: [],
      };
      this.serviceList.map((ele) => {
        ele.price = 0;
        ele.isLeisure = false;
      });
      this.$http.post("dWorker/serviceByWorker/" + id).then((res) => {
        this.showPrice = res.body.data.showPrice / 100;
        this.subscribe = res.body.data.subscribe;
        this.subscribeTimes = res.body.data.subscribeTimes;
        res.body.data.servers.forEach((ele) => {
          this.serviceList.forEach((service) => {
            if (ele.serverId == service.id) {
              service.workerId = ele.workerId;
              service.type = ele.type;
              service.isLeisure = ele.isLeisure;
              service.tag = ele.tag;
              service.serviceManTime = ele.serviceManTime;
              service.serviceWomanTime = ele.serviceWomanTime;
              service.price = ele.price / 100;
              service.commission = ele.commission / 100;
              if (ele.leisureStartTime) {
                service.leisureStartTime = ele.leisureStartTime.substring(0, 5);
                service.leisureEndTime = ele.leisureEndTime.substring(0, 5);
                service.leisurePrice = ele.leisurePrice / 100;
              }
              this.setObj.serviceList.push(service);
            }
          });
        });
        this.loading = false;
      });
    },
    // 筛选获取发型师列表，并赋值到表格
    getWorkerList () {
      this.loading = true;
      var query = "page=" + this.form.page + "&size=" + this.form.size;
      if (this.form.name.trim().length > 0) query += "&name=" + this.form.name;
      if (this.form.shop != "") query += "&storeId=" + this.form.shop;
      if (this.form.state != "") query += "&status=" + this.form.state;
      if (this.form.workerStatus != null) query += "&workerStatus=" + this.form.workerStatus;
      if (this.form.type != "") query += "&type=" + this.form.type;
      if (this.form.isRemove != "" || this.form.isRemove != null) query += "&isRemove=" + this.form.isRemove;
      if (this.form.value != "" && this.form.value != null) query += "&joinTime=" + this.form.value;
      this.$http.get("dWorker/queryAll?" + query).then((res) => {
        this.form.page = res.body.data.current;
        this.form.size = res.body.data.size;
        this.form.total = res.body.data.total;
        this.workList = res.body.data.records.filter((e) => e.test == 0);
        this.workTestList = res.body.data.records.filter((e) => e.test == 1);
        this.loading = false;
      });
    },
    goInfo (id) {
      if (id)
        return this.$router.push({
          path: "/hairdetail",
          query: {
            id: id,
          },
        });
      return this.$router.push({
        path: "/hairdetail",
      });
    },
    out (obj) {
      this.$confirm("此操作将使发型师： “" + obj.name + "” 永久离职/删除, 是否继续?", "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$http.post("dWorker/del/" + obj.id).then((res) => {
          this.getWorkerList();
        });
      });
    },
    // 获得门店列表
    getStoreList () {
      this.$http.get("store/list").then((res) => {
        let arr = [];
        // res.body.data = res.body.data.filter(ele => ele.businessType == 0)
        // if(res.body.code=="200"){
        // 	for(let i in res.body.data){
        // 		let a={
        // 			value:res.body.data[i].id,
        // 			label:res.body.data[i].title
        // 		}
        // 		this.form.shops.push(a)
        // 	}
        // }
        res.body.data.forEach((ele) => {
          if (ele.businessType == 0) arr.push(ele);
        });
        this.form.shops = arr;
      });
    },
    setLeisure (id) {
      this.setObj.serviceList.forEach((ele) => {
        if (ele.id == id) {
          let a = ele.isLeisure == undefined || ele.isLeisure == false ? false : true;
          this.$http.post("dWorker/setLeisure?workerId=" + ele.workerId + "&serverId=" + ele.id + "&isLeisure=" + !a).then((res) => {
            if (res.body.code == 200) {
              this.$message.success("修改成功");
              this.getService(ele.workerId);
            } else {
              this.$message.error(res.body.msg);
            }
          });
        }
      });
    },
    setService () {
      let data = [];
      let flag = false;
      if (this.subscribe === 1 && this.subscribeTimes.length < 2) {
        this.$message.error("请选择预约时间");
        return;
      }
      if (this.setObj.serviceList.length) {
        this.setObj.serviceList.forEach((ele) => {
          if (ele.price < 0 || ele.commission < 0) {
            flag = true;
          } else {
            var arr = {
              workerId: this.setObj.id,
              serverId: ele.id,
              serviceManTime: ele.serviceManTime,
              serviceWomanTime: ele.serviceWomanTime,
              price: (ele.price * 100).toFixed(),
              commission: (ele.commission * 100).toFixed(),
              tag: ele.tag,
            };
            if (ele.leisureStartTime != null && ele.leisureStartTime != undefined) {
              (arr.leisureStartTime = ele.leisureStartTime + ":00"), (arr.leisureEndTime = ele.leisureEndTime + ":00");
            } else {
              arr.leisureStartTime = null;
              arr.leisureEndTime = null;
            }
            if (ele.leisurePrice != null && ele.leisurePrice != undefined) {
              arr.leisurePrice = (ele.leisurePrice * 100).toFixed();
            } else {
              arr.leisurePrice = 0;
            }
            arr.isLeisure = ele.isLeisure;
            data.push(arr);
          }
        });
      } else {
        data.push({
          workerId: this.setObj.id,
        });
      }
      // console.log(data)
      this.$http.post("dWorker/setService", JSON.stringify(data)).then((res) => {
        if (res.body.code == 200) {
          this.serviceWindow = false;
          this.$message.success("保存成功");
          this.getWorkerList();
        } else {
          this.$message.error(res.body.msg);
        }
      });
      let subscribeTime = this.subscribeTimes.join(",");
      let a = "?workerId=" + this.setObj.id + "&price=" + this.showPrice * 100 + "&subscribe=" + this.subscribe + "&subscribeTime=" + subscribeTime;
      this.$http.get("dWorker/saveShowPrice" + a).then((res) => {
        if (res.body.code == 200) {
          this.serviceWindow = false;
        } else {
          this.$message.error(res.body.msg);
        }
      });
    },
    getServiceList () {
      this.$http
        .post(
          "dhaircut/findDhaircutService",
          JSON.stringify({
            pageNum: 1,
            pageSize: 100,
          })
        )
        .then((res) => {
          // this.serviceList = res.body.data.records.filter(ele => ele.state == 1||ele.state == 0 && ele.remove==0);
          this.serviceList = res.body.data.records.filter((ele) => ele.remove == 0);
          this.serviceList.forEach((ele) => {
            ele.price = 0;
          });
        });
    },
    handleCommand (command) {
      this.$message("click on item " + command);
    },
    // 一键修改发型师状态
    changeWorkerStatus (command) {
      var s = "";
      if (command == 0) {
        s = "上班";
      } else if (command == 11) {
        s = "轻餐";
      } else if (command == 4) {
        s = "外出";
      } else if (command == 1) {
        s = "就餐";
      } else if (command == 3) {
        s = "即将下班";
      } else if (command == 2) {
        s = "休息";
      }
      this.$confirm("确定修改发型师状态为 " + s, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          if (this.ids != null) {
            if (this.ids.length == 0) {
              this.$message.error("没有选择发型师");
            } else {
              this.$http.get("dWorker/changeWorkerStatus?ids=" + this.ids + "&workerStatus=" + command).then((res) => {
                if (res.body.code == 200) {
                  this.$message.success("修改成功");
                  this.getWorkerList();
                  this.ids = [];
                } else {
                  this.$message.error("修改失败");
                }
              });
            }
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    // 一键修改发型师服务
    changeService (command) {
      if (command == null || command == "") {
        command = {
          title: "显示价格",
          id: "",
        };
      }
      this.$confirm("确定修改 [" + command.title + "] 为 " + this.price + " 元", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          if (this.ids != null) {
            if (this.ids.length == 0) {
              this.$message.error("没有选择发型师");
            } else {
              this.$http.get("dWorker/changeService?ids=" + this.ids + "&serviceId=" + command.id + "&price=" + (this.price * 100).toFixed()).then((res) => {
                if (res.body.code == 200) {
                  this.$message.success("修改成功");
                  this.getWorkerList();
                  this.ids = [];
                } else {
                  this.$message.error("修改失败");
                }
              });
            }
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    handleSelectionChange (val) {
      this.ids = [];
      const idsArray = val;
      if (idsArray != []) {
        if (idsArray.length > 0) {
          idsArray.forEach((item) => {
            this.ids.push(item.id);
          });
        }
      }
    },

    // 分页-每页大小发生改变时触发
    handleSizeChange (size) {
      this.form.size = size;
      this.getWorkerList();
    },
    // 分页-页数发生改变时触发
    handleCurrentChange (page) {
      this.form.page = page;
      this.getWorkerList();
    },
    //修改状态按钮
    handleStatusClick (id) {
      this.$http.get("dWorker/getById?id=" + id).then((res) => {
        if (res.body.data != null) {
          this.worker = res.body.data;
        }
      });
      this.changeDialog = true;
    },
    //更改状态
    saveWorkerStatus () {
      this.$http.post("dWorker/saveOrUpdate", JSON.stringify(this.worker)).then((res) => {
        if (res.body.code == 200) {
          this.$message.success("修改成功");
          this.changeDialog = false;
          this.getWorkerList();
        }
      });
    },
  },
  created () {
    this.getStoreList();
  },
  // 初始化
  mounted () {
    this.getWorkerList();
    this.getServiceList();
  },
};
</script>

<style>
.dialog-warpper {
  height: 75vh;
  overflow-y: scroll;
}

.el-input__inner {
  -webkit-appearance: none;
  background-color: #fff;
  background-image: none;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  box-sizing: border-box;
  color: #606266;
  display: inline-block;
  font-size: 15px;
  height: 40px;
  line-height: 40px;
  outline: 0;
  padding: 0 15px;
  transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  width: 100%;
}

.list-manage-time {
  float: right;
}

.clear {
  clear: both;
}

.left {
  float: left;
}

.right {
  float: right;
}

.top {
  margin-top: 20px;
}

.list-manage-time .el-form-item {
  margin-bottom: 10px;
}

.list-manage-text-right .el-select,
.list-manage-text-right .el-input {
  margin-right: 10px;
}

.list-manage-form {
  margin-top: 40px;
}

.list-manage-form .has-gutter th {
  text-align: center;
  line-height: 40px;
  background-color: #f4f1f4;
  font-size: 16px;
}

.list-manage-form .el-table__row td {
  text-align: center;
  font-size: 16px;
}

.list-manage-form .el-table__row td span {
  font-size: 16px;
}

.el-dropdown-link {
  cursor: pointer;
  color: #409eff;
}

.el-icon-arrow-down {
  font-size: 12px;
}
</style>
